import {IActiveShipment} from "@/models/StoreModels";
import {ACTIVE_SHIPMENT_STATUS, ACTIVE_SHIPMENT_TYPE} from "@/constants/orders";
import {map} from "ramda";

export class ShipmentLogic {

  // States
  public static isAwaitingDropoff(shipment: IActiveShipment): boolean {
    return shipment.status === ACTIVE_SHIPMENT_STATUS.STATUS_NEW ||
      shipment.status === ACTIVE_SHIPMENT_STATUS.STATUS_AWAITING_DROPOFF;
  }

  public static isToBeDelivered(shipment: IActiveShipment): boolean {
    return shipment.status === ACTIVE_SHIPMENT_STATUS.STATUS_AWAITING_COLLECT ||
      shipment.status === ACTIVE_SHIPMENT_STATUS.STATUS_PROCESSING;
  }

  public static isAwaitingPickup(shipment: IActiveShipment): boolean {
    return shipment.status === ACTIVE_SHIPMENT_STATUS.STATUS_AWAITING_PICKUP;
  }

  public static isCompleted(shipment: IActiveShipment): boolean {
    return shipment.status === ACTIVE_SHIPMENT_STATUS.STATUS_COMPLETED;
  }



  // validation hub_id

  public static destinationHubIsValid(shipment: IActiveShipment): boolean {
    return !!shipment.to_hub_id && shipment.to_hub_id > 0;
  }

  public static originHubIsValid(shipment: IActiveShipment): boolean {
    return !!shipment.from_hub_id && shipment.from_hub_id > 0;
  }

  // Crosstown related queries
  public static shipmentIsCrosstown(shipment: IActiveShipment): boolean {
    return shipment.type === ACTIVE_SHIPMENT_TYPE.TYPE_CROSSTOWN_DELIVERY;
  }

  public static userIsCrosstownSender(shipment: IActiveShipment, userId: number): boolean  {
    return this.shipmentIsCrosstown(shipment) && this.userIsSender(shipment, userId);
  }

  public static userIsCrosstownRecipient(shipment: IActiveShipment, userId: number): boolean  {
    return this.shipmentIsCrosstown(shipment) && this.userIsRecipient(shipment, userId);
  }

  // User related queries
  public static receiverCanInteract(shipment: IActiveShipment): boolean {
    return (this.isAwaitingPickup(shipment) || this.needsDestination(shipment));
  }

  public static senderCanInteract(shipment: IActiveShipment): boolean {
    return (this.isAwaitingDropoff(shipment));
  }

  public static userCanInteractWith(shipment: IActiveShipment, userId: number): boolean {
    return (this.userIsRecipient(shipment, userId) && this.receiverCanInteract(shipment))
      || (this.userIsSender(shipment, userId) && this.senderCanInteract(shipment));
  }

  public static userIsSender(shipment: IActiveShipment, userId: number): boolean {
    return shipment.from_user_id === userId;
  }

  public static userIsRecipient(shipment: IActiveShipment, userId: number): boolean {
    return shipment.to_user_id === userId;
  }

  // More abstract queries
  public static needsDestination(shipment: IActiveShipment): boolean {
    return !shipment.to_hub_id &&
      (shipment.status !== ACTIVE_SHIPMENT_STATUS.STATUS_DISCARDED) &&
      (shipment.status !== ACTIVE_SHIPMENT_STATUS.STATUS_NEW) &&
      (shipment.status !== ACTIVE_SHIPMENT_STATUS.STATUS_AWAITING_DROPOFF) &&
      (shipment.status !== ACTIVE_SHIPMENT_STATUS.STATUS_COMPLETED);
  }

  public static countOrdersWaitingUserAction = (orderList: IActiveShipment[], userId: number): number => {
    let userActionActiveOrders = 0;

    map((shipment: IActiveShipment) => {
      if (ShipmentLogic.userCanInteractWith(shipment, userId)) {
        userActionActiveOrders = userActionActiveOrders + 1;
      }
    }, orderList);

    return userActionActiveOrders;
  }

}
